const MonitoringScreens = {
  Monitoring: {
    PATH: '/monitoring',
    TITLE: 'Monitoring',
    TITLE_ALT: 'Monitoring',
    PERMISSION: '',
  },
  AuditTrail: {
    PATH: '/monitoring/audit-trail',
    TITLE: 'Audit Trail',
    TITLE_ALT: 'Audit Trail',
    PERMISSION: 'DASHBOARD_AUDIT_TRAIL.read',
  },
  SALES_ACTIVITY: {
    PATH: '/monitoring/sales-activity/:pos',
    TITLE: 'Monitoring',
    TITLE_ALT: 'Sales Activity',
    PERMISSION: 'MONITORING_SALES_ACTIVITY.read',
  },
  GEOTRACKING_GEOTAGGING: {
    PATH: '/monitoring/geotracking/:pos',
    TITLE: 'Monitoring',
    TITLE_ALT: 'Geotracking & Geotagging',
    PERMISSION: 'MONITOR_GEOTAGGING.read',
  },
  GEOTRACKING_GEOTAGGING_DETAIL: {
    PATH: '/monitoring/geotracking/:pos/detail/:id/:name',
    TITLE: 'Monitoring',
    TITLE_ALT: 'Geotracking & Geotagging',
    PERMISSION: 'MONITOR_GEOTAGGING.read',
  },
  APP_VERSION: {
    PATH: '/monitoring/app-version',
    TITLE: 'Application Version',
    TITLE_ALT: 'Application Version',
    PERMISSION: 'APP_VERSION.read',
  },
  APP_VERSION_EDIT: {
    PATH: '/monitoring/app-version/:type',
    TITLE: 'Application Version',
    TITLE_ALT: 'Edit Version',
    PERMISSION: 'APP_VERSION.insert_update',
  },
  INQUIRY_APPLICATION: {
    PATH: '/monitoring/inquiry-application',
    TITLE: 'Inquiry Application',
    TITLE_ALT: 'Inquiry Application',
    PERMISSION: 'INQUIRY_DATA.read',
  },
}

export default MonitoringScreens
